export default __webpack_public_path__ + "static/media/pf.5d921946.svg";